import { Component, Inject } from '@angular/core';
import { LocationTag, Tag } from '../../../models/tag.model';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';

@Component({
  selector: 'app-tags-modal',
  templateUrl: './tags-modal.component.html',
  styleUrl: './tags-modal.component.css'
})
export class TagsModalComponent {
  totalItems: number;
  displayedColumns: string[] = ['name', 'description', 'actions'];
  dataSource = new MatTableDataSource<Tag>();

  constructor(private dialogRef: MatDialogRef<TagsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tags: Tag[] },
    private snackBar: SnackbarService,
    private translationService: TranslationService) {

    data.tags.forEach(tag => {
      tag.formattedLocations = this.handleLocation(tag.locations);
    });

    this.dataSource.data = data.tags;
    this.totalItems = data.tags.length;
  }

  copyTag(name: string) {
    var result = '[' + name + "]";
    navigator.clipboard.writeText(result)
      .then(
        () => {
          var message = this.translationService.translate("Tag copied");
          this.snackBar.showCustom(message, 'content_copy');
        },
        (err) => {
          var message = this.translationService.translate("Error on copy tag");
          this.snackBar.showError(message)
        }
      )
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  handleLocation(locations: LocationTag[]) {
    const groupedLocations: { [key: string]: string[] } = {};
    locations.forEach(loc => {

      var type = this.translationService.translate(loc.type);

      if (!groupedLocations[type]) {
        groupedLocations[type] = [];
      }
      groupedLocations[type].push(loc.field);
    });

    let locationsString = "";
    for (const [type, fields] of Object.entries(groupedLocations)) {
      locationsString += `${type.toUpperCase()}:\n`;
      fields.forEach(field => {
        locationsString += `- ${field}\n`;
      });
      locationsString += "\n";
    }

    return locationsString.trim();
  }
}
